import React, { Component } from "react";
import "./index.css";

import ImgItem from "./components/ImgItem";
import ImgItemList from "./components/ImgItemList";
import Uploader from "./components/Uploader";
import TextField from "material-ui/TextField";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import Input, { InputLabel } from "material-ui/Input";
import { FormControl, FormHelperText } from "material-ui/Form";
import OverlayLoader from "../../components/OverlayLoader";
import scrollToElement from "../../util/scrollToElement";
import { supportedVideoFormats } from "./constants";
import CASE_TYPES from "../../constants/caseTypes";
import { getSizeLimitInMbs } from "./util";
import { constructPostSlugPath } from "../../util/index";
import Button from "../../components/Button";
import { Tooltip } from "react-tippy";
import {
  minimumCaseDescriptionLength,
  minimumCaseTitleLength,
  caseTitleErrorMessage,
  caseDescriptionErrorMessage,
  minimumImagesWarningMessage,
  missingCaptionsWarningMessage,
  warningConfirmButtonText,
  minimumImagesWarningCancelButtonText,
  missingCaptionsWarningCancelButtonText,
  caseDescriptionHelperMessage,
  minimumImagesCount,
} from "./constants";

class NewCase extends Component {
  constructor(props) {
    super(props);
    this.handleInfoChange = this.handleInfoChange.bind(this);
    this.publish = this.publish.bind(this);
    this.updateCaption = this.updateCaption.bind(this);
    this.toggleCoverImage = this.toggleCoverImage.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.shouldDisableSubmit = this.shouldDisableSubmit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.confirmCancel = this.confirmCancel.bind(this);
    this.setRejectedFilesState = this.setRejectedFilesState.bind(this);
    this.updateProgressInState = this.updateProgressInState.bind(this);
    this.checkAllImagesHaveCaptions = this.checkAllImagesHaveCaptions.bind(this);
    this.validateMinImageCount = this.validateMinImageCount.bind(this);
    this.confirmPublishPost = this.confirmPublishPost.bind(this);
    this.showImageCaptionTooltip = this.showImageCaptionTooltip.bind(this);

    this.state = {
      formState: "draft",
      caseTypes: CASE_TYPES,
      progress: {},
      rejectedTypesFileNames: [],
      rejectedSizesFileNames: [],
      isImageCaptionTooltipVisible: false,
    };
  }

  showImageCaptionTooltip() {
    this.setState(prevState => ({ ...prevState, isImageCaptionTooltipVisible: true }));
    setTimeout(() => {
      this.setState(prevState => ({ ...prevState, isImageCaptionTooltipVisible: false }));
    }, 3000);
  }

  confirmPublishPost(post) {
    this.props.actions.publish(post);
    this.props.actions.hideConfirmDialog();
  }

  validateMinImageCount(post) {
    if (this.props.data.images.length < minimumImagesCount) {
      this.props.actions.showConfirmDialog({
        onConfirm: () => this.confirmPublishPost(post),
        onCancel: this.props.actions.hideConfirmDialog,
        content: minimumImagesWarningMessage,
        confirmText: warningConfirmButtonText,
        cancelText: minimumImagesWarningCancelButtonText,
        confirmColor: "black",
        cancelColor: "blue",
      });
    } else {
      this.confirmPublishPost(post);
    }
  }

  checkAllImagesHaveCaptions() {
    const imagesWithNoCaption = this.props.data.images.filter(image => !image.caption);
    return imagesWithNoCaption.length === 0;
  }

  updateCaption(imageId) {
    return ev => {
      ev.persist();
      this.props.actions.updateCaption(imageId, ev.target.value);
    };
  }
  toggleCoverImage(coverImageId) {
    return _ => {
      this.props.actions.toggleCoverImage(coverImageId);
    };
  }
  deleteImage(imageId, fileId) {
    return _ => this.props.actions.deleteImage(imageId);
  }

  handleInfoChange(key) {
    return ev => {
      this.props.actions.handleInfoChange({ [key]: ev.target.value });
    };
  }
  publish() {
    let state = this.props.data;
    //TODO: handle case if user didn't finish uploading before publishing
    let post = {
      title: state.info.title,
      description: state.info.description,
      albumGuid: state.guid,
      caseType: state.info.caseType,
      images: state.images.map(({ id, uuid, caption = "", isCover, type }, index) => ({
        id,
        uuid,
        caption,
        index,
        isCover,
        type,
      })),
      _id: state._id,
      slug: state.slug,
    };
    let isFormValid = this.isFormValid();
    this.setState({ formState: !isFormValid ? "error" : "loading" });

    if (
      isFormValid &&
      !this.props.data.publishing &&
      this.props.data.images.length >= minimumImagesCount &&
      this.checkAllImagesHaveCaptions()
    ) {
      this.props.actions.publish(post);
    } else if (isFormValid && !this.props.data.publishing && !this.checkAllImagesHaveCaptions()) {
      this.props.actions.showConfirmDialog({
        onConfirm: () => this.validateMinImageCount(post),
        onCancel: this.props.actions.hideConfirmDialog,
        content: missingCaptionsWarningMessage,
        confirmText: warningConfirmButtonText,
        cancelText: missingCaptionsWarningCancelButtonText,
        confirmColor: "black",
        cancelColor: "blue",
      });
    } else if (isFormValid && !this.props.data.publishing && this.props.data.images.length < minimumImagesCount) {
      this.props.actions.showConfirmDialog({
        onConfirm: () => this.confirmPublishPost(post),
        onCancel: this.props.actions.hideConfirmDialog,
        content: minimumImagesWarningMessage,
        confirmText: warningConfirmButtonText,
        cancelText: minimumImagesWarningCancelButtonText,
        confirmColor: "black",
        cancelColor: "blue",
      });
    } else if (!this.props.data.info.title) {
      scrollToElement("#title", { offset: -80, align: "top" });
    } else if (!this.props.data.info.description) {
      scrollToElement("#description", { offset: -80, align: "top" });
    } else if (!this.props.data.info.caseType) {
      scrollToElement("#caseType", { offset: -80, align: "top" });
    } else if (this.props.data.images.length === 0) {
      scrollToElement("#selectPhotos", { offset: -80, align: "top" });
    } else {
      const firstCurrentlyUploadingImage = this.props.data.images.find(image => !image.uploaded);
      if (firstCurrentlyUploadingImage) {
        scrollToElement(`#${firstCurrentlyUploadingImage.id}`, {
          offset: -80,
          align: "top",
        });
      }
    }
  }

  setRejectedFilesState(rejectedFiles) {
    const { rejectedTypes = [], rejectedSizes = [] } = rejectedFiles;
    const rejectedTypesFileNames = rejectedTypes.map(file => file.name);
    const rejectedSizesFileNames = rejectedSizes.map(file => file.name);

    this.setState({
      rejectedTypesFileNames,
      rejectedSizesFileNames,
    });
  }
  updateProgressInState(name, percentage) {
    this.setState(prevState => ({
      ...prevState,
      progress: { ...prevState.progress, [name]: percentage },
    }));
  }

  isFormValid() {
    let { data } = this.props;
    let isAllUploaded = data.images.reduce((acc, image) => {
      return image.uploaded && acc;
    }, true);

    let isFormValid =
      !!data.info.title &&
      !!data.info.description &&
      !!data.info.caseType &&
      data.images.length > 0 &&
      data.info.description.length > minimumCaseDescriptionLength &&
      data.info.title.length > minimumCaseTitleLength &&
      isAllUploaded;
    return isFormValid;
  }

  shouldDisableSubmit() {
    return !this.isFormValid();
  }

  confirmCancel() {
    this.props.actions.showConfirmDialog({
      onConfirm: this.cancel,
      onCancel: this.props.actions.hideConfirmDialog,
      content: "Cancel editing this case?",
      confirmText: "Yes",
      cancelText: "No",
    });
  }

  cancel() {
    this.props.actions.hideConfirmDialog();
    // Do not go outside of our app
    if (this.props.prevRoute) {
      return this.props.actions.goBack();
    }

    const postPath = constructPostSlugPath(this.props.data);

    return this.props.actions.push(postPath);
  }

  render() {
    let isFormInvalid = this.state.formState === "error" && !this.isFormValid();

    return (
      <section className="new-case page">
        {this.props.loading ? <OverlayLoader size="big" /> : ""}
        <section className="-form-wrapper">
          <FormControl>
            <TextField
              helperText={this.props.data.info.title.length < minimumCaseTitleLength ? caseTitleErrorMessage : ""}
              label="Title"
              id="title"
              error={
                isFormInvalid &&
                (!this.props.data.info.title || this.props.data.info.title.length < minimumCaseTitleLength)
              }
              onChange={this.handleInfoChange("title")}
              value={this.props.data.info.title}
            />
          </FormControl>
          <FormControl>
            <TextField
              helperText={
                this.props.data.info.description.length < minimumCaseDescriptionLength
                  ? caseDescriptionErrorMessage
                  : ""
              }
              label="Description"
              id="description"
              multiline
              error={
                isFormInvalid &&
                (!this.props.data.info.description ||
                  this.props.data.info.description.length < minimumCaseDescriptionLength)
              }
              rows="3"
              rowsMax="30"
              onChange={this.handleInfoChange("description")}
              value={this.props.data.info.description}
            />
            <FormHelperText>{caseDescriptionHelperMessage}</FormHelperText>
          </FormControl>
          <FormControl>
            <InputLabel id="caseType" name="lel" htmlFor="case-type">
              CaseType
            </InputLabel>
            <Select
              value={this.props.data.info.caseType}
              error={isFormInvalid && !this.props.data.info.caseType}
              onChange={this.handleInfoChange("caseType")}
              input={<Input id="case-type" />}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {this.state.caseTypes.filter(({ hidden }) => !hidden).map(({ caseType, index }) => (
                <MenuItem key={index} value={`${index + 1}`} name="caseType">
                  {caseType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </section>

        <Uploader
          isEditForm={this.props.isEditForm}
          guid={this.props.data.guid}
          images={this.props.data.images}
          ownerId={this.props.data.owner && this.props.data.owner.id}
          accessToken={this.props.accessToken}
          setRejectedFilesState={this.setRejectedFilesState}
          updateProgressInState={this.updateProgressInState}
          handleChoosingImages={this.props.actions.handleChoosingImages}
          handleUploadedImage={this.props.actions.handleUploadedImage}
          handleUploadedImageError={this.props.actions.handleUploadedImageError}
          showImageCaptionTooltip={this.showImageCaptionTooltip}
          isAdminEdit={this.props.isAdminEdit}
        />
        {isFormInvalid && this.props.data.images.length === 0 ? (
          <span className="no-images-error"> You need to upload at least one image. </span>
        ) : (
          ""
        )}
        {this.state.rejectedTypesFileNames.length > 0 ? (
          <div className="unsupported-files-error">
            <span> The following files have unsupported formats: </span>
            <ul>{this.state.rejectedTypesFileNames.map((fileName, i) => <li key={i}> {fileName} </li>)}</ul>
            <span>
              {" "}
              You can upload any image format along with videos with the following formats:{" "}
              {supportedVideoFormats.join(", ").replace(/video\//g, ".")}
              {". "}
            </span>
          </div>
        ) : null}
        {this.state.rejectedSizesFileNames.length > 0 ? (
          <div className="unsupported-files-error">
            <span> The following files exceed the size limit: </span>
            <ul>{this.state.rejectedSizesFileNames.map((fileName, i) => <li key={i}> {fileName} </li>)}</ul>
            <span>You can upload files with sizes up to {getSizeLimitInMbs()} MBs</span>
          </div>
        ) : null}
        <section id="images" className="-preview-photos">
          <ImgItemList
            onSortEnd={(...props) => {
              this.props.actions.onSortEnd(...props);
            }}
          >
            {this.props.data.images.map((img, index) => {
              return this.props.data.images.length === 1 ? (
                <Tooltip
                  open={this.state.isImageCaptionTooltipVisible}
                  position="top"
                  arrow="true"
                  title="Image uploaded! Now add caption or select as a cover photo"
                >
                  <ImgItem
                    key={img.id}
                    index={index}
                    img={{ ...img, progress: this.state.progress[img.name] }}
                    toggleCoverImage={this.toggleCoverImage}
                    updateCaption={this.updateCaption}
                    deleteImage={this.deleteImage}
                  />
                </Tooltip>
              ) : (
                <ImgItem
                  key={img.id}
                  index={index}
                  img={{ ...img, progress: this.state.progress[img.name] }}
                  toggleCoverImage={this.toggleCoverImage}
                  updateCaption={this.updateCaption}
                  deleteImage={this.deleteImage}
                />
              );
            })}
          </ImgItemList>
        </section>

        <div className="-button-group">
          {this.props.isEditForm ? <Button className="-cancel" value="Cancel" onClick={this.confirmCancel} /> : null}
          <Button
            className={`${!this.isFormValid() ? "-disabled" : ""}`}
            onClick={this.publish}
            value={this.props.isEditForm ? "Save Changes" : "Submit Case"}
          />
        </div>
      </section>
    );
  }
}

export default NewCase;



// WEBPACK FOOTER //
// ./src/scenes/NewCase/index.js